import { createContext } from 'react';
import { Linking } from 'react-native';
export const NavigationContext = createContext({
    onNavigateToItem: (item) => {
        console.log('Navigation not implemented. Attempting to navigate to', item);
    },
    onNavigate: (to) => Linking.openURL(to),
});
//# sourceMappingURL=NavigationContext.js.map